import Api from '@/services/Api'

export default {
  // Método que llama a la url para crear un chat
  getCovidList (params) {
   return Api().get("/all-covids/"+params);
  },
  getCovidsByUser (params,getValue) {    
    return Api().get("/covids-by-user/"+params+"/"+getValue);
  },
  updateCovid (params) {
    return Api().put("/covids",params);
  },
  addCovid (params) {
    return Api().post("/covids",params);
  },
  getCovid (params) {
    return Api().get("/covids/"+params);
  },
  deleteCovid (params) {
    return Api().delete("/covids/"+params);
  },
  existCovid (params){
    return Api().get("/covids/exist/"+params);
  },
  getLastCovid (params){
    return Api().get("/covids/last-covid/"+params);
  }

}



// WEBPACK FOOTER //
// ./src/services/CovidService.js